import React, { useEffect, useState } from "react";

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000"
).replace(/\/+$/, "");

const CONSENT_STORAGE_KEY = "demirsan_cookie_consent_v1";

function Consents() {
  const [visible, setVisible] = useState(false);

  const [permissionsOpen, setPermissionsOpen] = useState(false);

  const [policyOpen, setPolicyOpen] = useState(false);

  const [policyLoading, setPolicyLoading] = useState(false);

  const [policyError, setPolicyError] = useState("");

  const [policyData, setPolicyData] = useState({
    title: "",
    editor: "",
  });

  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  /*
  |--------------------------------------------------------------------------
  | DAHA ÖNCE SEÇİM YAPILMIŞ MI?
  |--------------------------------------------------------------------------
  */
  useEffect(() => {
    try {
      const saved = localStorage.getItem(CONSENT_STORAGE_KEY);

      if (!saved) {
        setVisible(true);
        return;
      }

      const parsed = JSON.parse(saved);

      setPreferences({
        necessary: true,
        analytics: parsed?.analytics === true,
        marketing: parsed?.marketing === true,
      });

      setVisible(false);
    } catch (error) {
      console.error("COOKIE_CONSENT_READ_ERROR:", error);

      setVisible(true);
    }
  }, []);

  /*
  |--------------------------------------------------------------------------
  | TERCİH KAYDET
  |--------------------------------------------------------------------------
  */
  const saveConsent = (values) => {
    const data = {
      necessary: true,

      analytics: values.analytics === true,

      marketing: values.marketing === true,

      saved_at: new Date().toISOString(),
    };

    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(data));

    setPreferences(data);

    setVisible(false);

    setPermissionsOpen(false);

    /*
     * App.js tarafında Analytics gibi servislerin
     * consent değişikliğini dinleyebilmesi için.
     */
    window.dispatchEvent(
      new CustomEvent("demirsanCookieConsentChanged", {
        detail: data,
      }),
    );
  };

  /*
  |--------------------------------------------------------------------------
  | TÜMÜNÜ KABUL ET
  |--------------------------------------------------------------------------
  */
  const acceptAll = () => {
    saveConsent({
      necessary: true,
      analytics: true,
      marketing: true,
    });
  };

  /*
  |--------------------------------------------------------------------------
  | REDDET
  |--------------------------------------------------------------------------
  */
  const rejectOptional = () => {
    saveConsent({
      necessary: true,
      analytics: false,
      marketing: false,
    });
  };

  /*
  |--------------------------------------------------------------------------
  | SEÇİMLERİ KAYDET
  |--------------------------------------------------------------------------
  */
  const savePreferences = () => {
    saveConsent(preferences);
  };

  const fetchCookiePolicy = async () => {
    try {
      setPolicyError("");

      const response = await fetch(`${API_BASE_URL}/api/contract/212`);

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data?.message || data?.msg || "Çerez politikası alınamadı.",
        );
      }

      const result = {
        title: data?.title || "Çerez Politikası",
        editor: data?.editor || "",
      };

      setPolicyData(result);

      return result;
    } catch (error) {
      console.error("COOKIE_POLICY_ERROR:", error);

      setPolicyError("Çerez Politikası yüklenirken bir hata oluştu.");

      return null;
    }
  };

  useEffect(() => {
    fetchCookiePolicy();
  }, []);

  const openCookiePolicy = async () => {
    /*
     * İçerik hazırsa modalı direkt aç.
     */
    if (policyData.editor) {
      setPolicyOpen(true);
      return;
    }

    /*
     * Henüz yüklenmediyse önce yükle,
     * ardından modalı aç.
     */
    const data = await fetchCookiePolicy();

    if (data) {
      setPolicyOpen(true);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | MODALLAR AÇIKKEN BODY SCROLL
  |--------------------------------------------------------------------------
  */
  useEffect(() => {
    if (!policyOpen && !permissionsOpen) {
      return;
    }

    const oldOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setPolicyOpen(false);
        setPermissionsOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = oldOverflow;

      document.removeEventListener("keydown", handleEscape);
    };
  }, [policyOpen, permissionsOpen]);

  return (
    <>
      <style>
        {`

        /*
        |--------------------------------------------------------------------------
        | ÇEREZ BANNER
        |--------------------------------------------------------------------------
        */

        .demirsan-cookie-banner {
          position: fixed;

          left: 0;
          right: 0;
          bottom: 18px;

          z-index: 999990;

          width: 100%;

          padding: 16px 22px;

          border-top:
            4px solid #e60000;

          background:
            #0b1735;

          box-shadow:
            0 -5px 25px
            rgba(0, 0, 0, .16);
        }


        .demirsan-cookie-inner {
          display: flex;

          align-items: center;
          justify-content:
            space-between;

          gap: 30px;

          width: 100%;
          max-width: 1600px;

          margin: 0 auto;
        }


        .demirsan-cookie-text {
          flex: 1;

          min-width: 0;

          margin: 0;

          color:
            rgba(255,255,255,.90);

          font-size: 13px;
          font-weight: 400;

          line-height: 1.65;
        }


        .demirsan-cookie-policy-link {
          display: inline !important;

          width: auto !important;
          height: auto !important;

          margin: 0 3px !important;
          padding: 0 !important;

          border: 0 !important;

          background:
            transparent !important;

          box-shadow:
            none !important;

          color:
            #ff4a4a !important;

          font-family:
            inherit !important;

          font-size:
            inherit !important;

          font-weight:
            700 !important;

          line-height:
            inherit !important;

          text-decoration:
            underline;

          text-underline-offset:
            2px;

          cursor: pointer;
        }


        .demirsan-cookie-policy-link:hover {
          color:
            #ffffff !important;
        }


        .demirsan-cookie-actions {
          display: flex;

          align-items: center;

          gap: 9px;

          flex-shrink: 0;
        }


        .demirsan-cookie-button {
          display: inline-flex;

          align-items: center;
          justify-content: center;

          min-height: 38px;

          padding: 8px 17px;

          border-radius: 7px;

          font-size: 13px;
          font-weight: 600;

          white-space: nowrap;

          cursor: pointer;

          transition:
            all .2s ease;
        }


        .demirsan-cookie-button-settings {
          border:
            1px solid
            rgba(255,255,255,.40);

          background:
            transparent;

          color: #ffffff;
        }


        .demirsan-cookie-button-settings:hover {
          border-color:
            #ffffff;

          background:
            rgba(255,255,255,.08);
        }


        .demirsan-cookie-button-reject {
          border:
            1px solid #ffffff;

          background:
            #ffffff;

          color:
            #0b1735;
        }


        .demirsan-cookie-button-reject:hover {
          background:
            #f1f1f1;
        }


        .demirsan-cookie-button-accept {
          border:
            1px solid #e60000;

          background:
            #e60000;

          color:
            #ffffff;
        }


        .demirsan-cookie-button-accept:hover {
          border-color:
            #c90000;

          background:
            #c90000;
        }



        /*
        |--------------------------------------------------------------------------
        | ORTAK MODAL
        |--------------------------------------------------------------------------
        */

        .demirsan-cookie-overlay {
          position: fixed;

          inset: 0;

          z-index: 1000000;

          display: flex;

          align-items: center;
          justify-content: center;

          padding: 24px;

          background:
            rgba(5, 13, 31, .72);

          backdrop-filter:
            blur(4px);
        }


        .demirsan-cookie-modal {
          display: flex;

          flex-direction: column;

          width:
            min(850px, 100%);

          max-height:
            calc(100vh - 48px);

          overflow: hidden;

          border-radius: 14px;

          background:
            #ffffff;

          box-shadow:
            0 25px 80px
            rgba(0,0,0,.30);
        }


        .demirsan-cookie-modal-header {
          display: flex;

          align-items: flex-start;
          justify-content:
            space-between;

          gap: 20px;

          padding: 22px 25px;

          border-bottom:
            1px solid #eceef2;

          border-top:
            4px solid #e60000;
        }


        .demirsan-cookie-modal-label {
          display: block;

          margin-bottom: 5px;

          color: #e60000;

          font-size: 12px;
          font-weight: 700;

          letter-spacing: .6px;

          text-transform:
            uppercase;
        }


        .demirsan-cookie-modal-title {
          margin: 0;

          color: #0b1735;

          font-size: 21px;
          font-weight: 700;

          line-height: 1.35;
        }


        .demirsan-cookie-modal-close {
          display: flex;

          align-items: center;
          justify-content: center;

          flex: 0 0 38px;

          width: 38px;
          height: 38px;

          margin: 0;
          padding: 0;

          border: 0;
          border-radius: 50%;

          background:
            #f3f4f6;

          color:
            #5d6677;

          font-size: 24px;

          cursor: pointer;
        }


        .demirsan-cookie-modal-close:hover {
          background:
            #e60000;

          color: #ffffff;
        }


        .demirsan-cookie-modal-body {
          flex: 1;

          min-height: 0;

          padding: 25px;

          overflow-y: auto;

          color: #4f5b6e;

          font-size: 14px;

          line-height: 1.8;
        }


        .demirsan-cookie-policy-content p {
          margin:
            0 0 14px;
        }


        .demirsan-cookie-policy-content h1,
        .demirsan-cookie-policy-content h2,
        .demirsan-cookie-policy-content h3,
        .demirsan-cookie-policy-content h4,
        .demirsan-cookie-policy-content h5,
        .demirsan-cookie-policy-content h6 {
          margin:
            20px 0 10px;

          color: #0b1735;

          font-weight: 700;
        }


        .demirsan-cookie-policy-content ul,
        .demirsan-cookie-policy-content ol {
          padding-left: 22px;
        }


        .demirsan-cookie-loading,
        .demirsan-cookie-error {
          padding:
            40px 15px;

          text-align: center;
        }


        .demirsan-cookie-error {
          color: #d40000;
        }



        /*
        |--------------------------------------------------------------------------
        | İZİNLER
        |--------------------------------------------------------------------------
        */

        .demirsan-cookie-permission {
          display: flex;

          align-items: center;
          justify-content:
            space-between;

          gap: 25px;

          padding: 18px 0;

          border-bottom:
            1px solid #eceef2;
        }


        .demirsan-cookie-permission:first-child {
          padding-top: 0;
        }


        .demirsan-cookie-permission:last-child {
          border-bottom: 0;
        }


        .demirsan-cookie-permission-info {
          flex: 1;
        }


        .demirsan-cookie-permission-info h5 {
          margin:
            0 0 5px;

          color: #0b1735;

          font-size: 15px;
          font-weight: 700;
        }


        .demirsan-cookie-permission-info p {
          margin: 0;

          color: #667085;

          font-size: 13px;
          line-height: 1.6;
        }


        .demirsan-cookie-required {
          color: #258344;

          font-size: 12px;
          font-weight: 700;
        }



        /*
        |--------------------------------------------------------------------------
        | SWITCH
        |--------------------------------------------------------------------------
        */

        .demirsan-cookie-switch {
          position: relative;

          flex: 0 0 46px;

          width: 46px;
          height: 25px;
        }


        .demirsan-cookie-switch input {
          position: absolute;

          width: 1px;
          height: 1px;

          opacity: 0;
        }


        .demirsan-cookie-slider {
          position: absolute;

          inset: 0;

          border-radius: 30px;

          background:
            #c7ccd4;

          cursor: pointer;

          transition:
            .2s ease;
        }


        .demirsan-cookie-slider::before {
          content: "";

          position: absolute;

          top: 3px;
          left: 3px;

          width: 19px;
          height: 19px;

          border-radius: 50%;

          background:
            #ffffff;

          box-shadow:
            0 2px 6px
            rgba(0,0,0,.18);

          transition:
            .2s ease;
        }


        .demirsan-cookie-switch
        input:checked +
        .demirsan-cookie-slider {
          background:
            #e60000;
        }


        .demirsan-cookie-switch
        input:checked +
        .demirsan-cookie-slider::before {
          transform:
            translateX(21px);
        }



        /*
        |--------------------------------------------------------------------------
        | MODAL FOOTER
        |--------------------------------------------------------------------------
        */

        .demirsan-cookie-modal-footer {
          display: flex;

          align-items: center;
          justify-content: center;

          gap: 10px;

          padding: 16px 25px;

          border-top:
            1px solid #eceef2;

          background:
            #fafafa;
        }


       .demirsan-cookie-modal-save {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;

  flex: 0 0 auto !important;

  width: auto !important;
  min-width: 120px !important;
  max-width: max-content !important;

  height: auto !important;
  min-height: 38px !important;

  margin: 0 auto !important;
  padding: 8px 16px !important;

  border: 0 !important;
  border-radius: 6px !important;

  background: #e60000 !important;
  color: #ffffff !important;

  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;

  white-space: nowrap !important;

  cursor: pointer;
}

        .demirsan-cookie-modal-save:hover {
          background:
            #c90000;
        }



        /*
        |--------------------------------------------------------------------------
        | MOBILE
        |--------------------------------------------------------------------------
        */

        @media (max-width: 767px) {

          .demirsan-cookie-banner {
            bottom: 10px;

            padding:
              15px 16px;
          }


          .demirsan-cookie-inner {
            flex-direction:
              column;

            align-items:
              stretch;

            gap: 15px;
          }


          .demirsan-cookie-text {
            font-size: 12.5px;
          }


          .demirsan-cookie-actions {
            display: grid;

            grid-template-columns:
              1fr 1fr;
          }


          .demirsan-cookie-button-accept {
            grid-column:
              1 / -1;
          }


          .demirsan-cookie-button {
            width: 100%;
          }


          .demirsan-cookie-overlay {
            padding: 10px;
          }


          .demirsan-cookie-modal {
            max-height:
              calc(100vh - 20px);

            border-radius: 10px;
          }


          .demirsan-cookie-modal-header {
            padding: 17px;
          }


          .demirsan-cookie-modal-body {
            padding: 18px;
          }


          .demirsan-cookie-permission {
            gap: 15px;
          }

        }
          /*
|--------------------------------------------------------------------------
| AYDINLATMA / ÇEREZ POLİTİKASI ORTAK MODAL
|--------------------------------------------------------------------------
*/

.demirsan-contract-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000000;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 24px;

  background: rgba(7, 16, 36, 0.72);
  backdrop-filter: blur(4px);
}

.demirsan-contract-modal {
  position: relative;

  display: flex;
  flex-direction: column;

  width: min(900px, 100%);
  max-height: calc(100vh - 48px);

  overflow: hidden;

  border-top: 4px solid #e60000;
  border-radius: 14px;

  background: #ffffff;

  box-shadow:
    0 25px 80px
    rgba(0, 0, 0, 0.28);
}

.demirsan-contract-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  gap: 20px;

  padding: 22px 25px;

  border-bottom: 1px solid #eceef2;

  background: #ffffff;
}

.demirsan-contract-heading {
  min-width: 0;
}

.demirsan-contract-label {
  display: block;

  margin-bottom: 4px;

  color: #e60000;

  font-size: 12px;
  font-weight: 700;

  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.demirsan-contract-title {
  margin: 0;

  color: #0b1735;

  font-size: 21px;
  font-weight: 700;

  line-height: 1.35;
}

.demirsan-contract-close {
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 0 0 38px;

  width: 38px;
  height: 38px;

  margin: 0;
  padding: 0;

  border: 0;
  border-radius: 50%;

  background: #f4f5f7;
  color: #5d6677;

  font-size: 24px;
  line-height: 1;

  cursor: pointer;
}

.demirsan-contract-close:hover {
  background: #e60000;
  color: #ffffff;
}

.demirsan-contract-body {
  flex: 1;

  padding: 26px;

  overflow-y: auto;

  color: #4f5b6e;

  font-size: 14px;
  line-height: 1.8;
}

.demirsan-contract-content {
  color: #4f5b6e;

  font-size: 14px;
  line-height: 1.8;
}

.demirsan-contract-content p {
  margin: 0 0 14px;
}

.demirsan-contract-content h1,
.demirsan-contract-content h2,
.demirsan-contract-content h3,
.demirsan-contract-content h4,
.demirsan-contract-content h5,
.demirsan-contract-content h6 {
  margin-top: 22px;
  margin-bottom: 10px;

  color: #0b1735;

  font-weight: 700;
}

.demirsan-contract-content ul,
.demirsan-contract-content ol {
  padding-left: 22px;
}

.demirsan-contract-content a {
  color: #e60000;
}

.demirsan-contract-loading,
.demirsan-contract-error,
.demirsan-contract-empty {
  padding: 45px 15px;

  text-align: center;

  font-size: 14px;
}

.demirsan-contract-loading {
  color: #657083;
}

.demirsan-contract-error {
  color: #d40000;
}

.demirsan-contract-empty {
  color: #7a8494;
}

.demirsan-contract-footer {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 16px 25px;

  border-top: 1px solid #eceef2;

  background: #fafafa;
}

.demirsan-contract-footer-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;

  width: auto !important;
  min-width: 90px !important;

  padding: 9px 18px !important;

  border: 0;
  border-radius: 6px;

  background: #0b1735;
  color: #ffffff;

  font-size: 13px;
  font-weight: 600;

  cursor: pointer;
}

.demirsan-contract-footer-button:hover {
  background: #e60000;
}

@media (max-width: 767px) {
  .demirsan-contract-overlay {
    padding: 10px;
  }

  .demirsan-contract-modal {
    max-height: calc(100vh - 20px);

    border-radius: 10px;
  }

  .demirsan-contract-header {
    padding: 17px;
  }

  .demirsan-contract-title {
    font-size: 18px;
  }

  .demirsan-contract-body {
    padding: 18px;

    font-size: 13px;
  }

  .demirsan-contract-footer {
    padding: 13px 17px;
  }

  .demirsan-contract-footer-button {
    width: auto !important;
    min-width: 90px !important;
  }
}

        `}
      </style>

      {/* ====================================================
          ÇEREZ BANNER
      ===================================================== */}
      {visible && (
        <div className="demirsan-cookie-banner">
          <div className="demirsan-cookie-inner">
            <p className="demirsan-cookie-text">
              Gelişmiş bir deneyim sunmak için çerezleri kullanıyoruz. Detaylı
              bilgi için{" "}
              <button
                type="button"
                className="demirsan-cookie-policy-link"
                onClick={openCookiePolicy}
              >
                Çerez Politikamızı
              </button>{" "}
              inceleyebilirsiniz.
            </p>

            <div className="demirsan-cookie-actions">
              <button
                type="button"
                className="
                  demirsan-cookie-button
                  demirsan-cookie-button-settings
                "
                onClick={() => setPermissionsOpen(true)}
              >
                İzinler
              </button>

              <button
                type="button"
                className="
                  demirsan-cookie-button
                  demirsan-cookie-button-reject
                "
                onClick={rejectOptional}
              >
                Reddet
              </button>

              <button
                type="button"
                className="
                  demirsan-cookie-button
                  demirsan-cookie-button-accept
                "
                onClick={acceptAll}
              >
                Onaylıyorum
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ====================================================
          İZİNLER MODAL
      ===================================================== */}
      {permissionsOpen && (
        <div
          className="demirsan-cookie-overlay"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setPermissionsOpen(false);
            }
          }}
        >
          <div className="demirsan-cookie-modal">
            <div className="demirsan-cookie-modal-header">
              <div>
                <span className="demirsan-cookie-modal-label">
                  ÇEREZ TERCİHLERİ
                </span>

                <h3 className="demirsan-cookie-modal-title">
                  İzinlerinizi Yönetin
                </h3>
              </div>

              <button
                type="button"
                className="demirsan-cookie-modal-close"
                onClick={() => setPermissionsOpen(false)}
                aria-label="Kapat"
              >
                ×
              </button>
            </div>

            <div className="demirsan-cookie-modal-body">
              {/* ZORUNLU */}
              <div className="demirsan-cookie-permission">
                <div className="demirsan-cookie-permission-info">
                  <h5>Zorunlu Çerezler</h5>

                  <p>
                    Web sitesinin temel fonksiyonlarının çalışması için
                    gereklidir.
                  </p>
                </div>

                <span className="demirsan-cookie-required">
                  Her Zaman Aktif
                </span>
              </div>

              {/* ANALİTİK */}
              <div className="demirsan-cookie-permission">
                <div className="demirsan-cookie-permission-info">
                  <h5>Analitik Çerezler</h5>

                  <p>
                    Ziyaretçilerin siteyi nasıl kullandığını anlamamıza yardımcı
                    olur.
                  </p>
                </div>

                <label className="demirsan-cookie-switch">
                  <input
                    type="checkbox"
                    checked={preferences.analytics}
                    onChange={(event) =>
                      setPreferences((old) => ({
                        ...old,

                        analytics: event.target.checked,
                      }))
                    }
                  />

                  <span className="demirsan-cookie-slider" />
                </label>
              </div>

              {/* PAZARLAMA */}
              <div className="demirsan-cookie-permission">
                <div className="demirsan-cookie-permission-info">
                  <h5>Pazarlama Çerezleri</h5>

                  <p>
                    Kişiselleştirilmiş içerik ve pazarlama faaliyetleri için
                    kullanılabilir.
                  </p>
                </div>

                <label className="demirsan-cookie-switch">
                  <input
                    type="checkbox"
                    checked={preferences.marketing}
                    onChange={(event) =>
                      setPreferences((old) => ({
                        ...old,

                        marketing: event.target.checked,
                      }))
                    }
                  />

                  <span className="demirsan-cookie-slider" />
                </label>
              </div>
            </div>

            <div className="demirsan-cookie-modal-footer">
              <button
                type="button"
                className="demirsan-cookie-modal-save"
                onClick={savePreferences}
              >
                Tercihleri Kaydet
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ====================================================
          ÇEREZ POLİTİKASI MODAL
      ===================================================== */}
      {/* ====================================================
    ÇEREZ POLİTİKASI MODAL
===================================================== */}
      {policyOpen && (
        <div
          className="demirsan-contract-overlay"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setPolicyOpen(false);
            }
          }}
        >
          <div
            className="demirsan-contract-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="cookie-policy-modal-title"
          >
            {/* HEADER */}
            <div className="demirsan-contract-header">
              <div className="demirsan-contract-heading">
                <span className="demirsan-contract-label">
                  Çerez Politikası
                </span>

                <h3
                  id="cookie-policy-modal-title"
                  className="demirsan-contract-title"
                >
                  {policyData.title || "Çerez Politikası"}
                </h3>
              </div>

              <button
                type="button"
                className="demirsan-contract-close"
                onClick={() => setPolicyOpen(false)}
                aria-label="Kapat"
              >
                ×
              </button>
            </div>

            <div className="demirsan-contract-body">
              {policyError ? (
                <div className="demirsan-contract-error">{policyError}</div>
              ) : policyData.editor ? (
                <div
                  className="demirsan-contract-content"
                  dangerouslySetInnerHTML={{
                    __html: policyData.editor,
                  }}
                />
              ) : null}
            </div>

            {/* FOOTER */}
            <div className="demirsan-contract-footer">
              <button
                type="button"
                className="demirsan-contract-footer-button"
                onClick={() => setPolicyOpen(false)}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Consents;
